import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
// @ts-expect-error i know this
import "swiper/css/effect-coverflow";

// Add this to your existing imports
import type { Swiper as SwiperType } from "swiper";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useTaskCategoryListOptions } from "@/pages/get-don/tasks.api";
import { useCategoryStore } from "@/pages/get-don/store/category.store";
import { useEffect, useRef, useState } from "react";
import TasksList from "../common/tasks/TasksList";

const SwiperContent = () => {
  const { data: categoryList } = useSuspenseQuery(useTaskCategoryListOptions());
  const { selectedCategory, setSelectedCategory } = useCategoryStore();
  const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);
  const prevCategoryIndex = useRef(selectedCategory.idx);

  // Sync Swiper with external state changes
  useEffect(() => {
    if (swiperInstance && selectedCategory.idx !== swiperInstance.activeIndex) {
      swiperInstance.slideTo(selectedCategory.idx, 300, false);
    }
  }, [selectedCategory.idx, swiperInstance]);

  // Handle smooth tab indicator animation direction
  // const getAnimationDirection = (newIndex: number) => {
  //   return newIndex > prevCategoryIndex.current ? 1 : -1;
  // };

  return (
    <div className="w-full">
      <Swiper
        speed={300}
        spaceBetween={20}
        slidesPerView={1}
        effect="slide"
        grabCursor={true}
        initialSlide={selectedCategory.idx}
        centeredSlides={true}
        onSwiper={setSwiperInstance}
        onSlideChange={(swiper) => {
          prevCategoryIndex.current = swiper.activeIndex;

          setSelectedCategory({
            id: categoryList[swiper.activeIndex].id,
            idx: swiper.activeIndex,
            isCollection:
              categoryList[swiper.activeIndex].is_collection_category,
          });
        }}
        className="!overflow-visible"
      >
        {categoryList.map((category) => (
          <SwiperSlide key={category.id}>
            {({ isActive }) => (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{
                  opacity: isActive ? 1 : 0,
                  x: 0,
                }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  damping: 30,
                  mass: 0.5,
                }}
                className="h-full"
              >
                {isActive && <TasksList />}
              </motion.div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperContent;
